const content = {
  audios: [
    {
      img: process.env.PUBLIC_URL + '/assets/img2.jpg',
      placeholder: process.env.PUBLIC_URL + '/assets/placeholder.jpg',
      src: process.env.PUBLIC_URL + '/assets/audio2.mp3',
      artist: 'Anno Domini Beats',
      songName: 'Sunny Day',
    },
    {
      img: process.env.PUBLIC_URL + '/assets/img1.jpg',
      placeholder: process.env.PUBLIC_URL + '/assets/placeholder.jpg',

      src: process.env.PUBLIC_URL + '/assets/audio3.mp3',
      artist: 'LATASHÁ',
      songName: 'Sweet Tides',
    },
    {
      img: process.env.PUBLIC_URL + '/assets/img3.jpg',
      placeholder: process.env.PUBLIC_URL + '/assets/placeholder.jpg',

      src: process.env.PUBLIC_URL + '/assets/audio1.mp3',

      artist: 'Audio Hertz',
      songName: 'Late Truth',
    },
  ],
  listTypes: [
    'bars',
    `bars blocks`,
    `big bars`,
    `cubes`,
    `dualbars`,
    `dualbars blocks`,
    `fireworks`,
    `flower`,
    `flower blocks`,
    `orbs`,
    `ring`,
    `rings`,
    `round wave`,
    `shine`,
    `shine rings`,
    `shockwave`,
    `star`,
    `static`,
    `stitches`,
    `web`,
    `wave`,
  ],
};

export default content;
